export class SolrFilters {
   path: string;
   competenza?: string;
   token?: string;
   term?: string;
   tipo?: string;
   codice_catastale?: string;
   constructor() { }
}
